<template>
  <div>
    <template v-if="isEmpty">
      <lxm-empty :text="'登录灵析电脑版，可以新建活动哦～'"></lxm-empty>
    </template>
    <template v-else>
      <template v-if="blocked">
        <lxm-blocked :text="'如需在手机上查看数据，请登录电脑升级为付费版哦。'"></lxm-blocked>
      </template>
      <template v-else>
        <div class="page">
          <div>
            <transition-group name="lxm-content-transition" tag="div" mode="out-in">
              <lxm-activity-item v-for="item in items"
                                 :key="item"
                                 :id="item.id"
                                 :title="item.title"
                                 :value="item.signedUpUserCount"
                                 :valueSuffix="item.valueSuffix"
                                 :to="item.to"></lxm-activity-item>
            </transition-group>
          </div>
          <lxm-more v-if="hasMore" :loading="loading" @click="moreClicked"></lxm-more>
        </div>
      </template>
    </template>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
</style>

<script>
  import LxmNav from '@/components/Main/common/LxmNav.vue'
  import LxmActivityItem from '@/components/Main/common/LxmActivityItem.vue'
  import LxmMore from '@/components/Main/common/LxmMore.vue'
  import LxmBottomTabs from '@/components/Main/common/LxmBottomTabs.vue'
  import LxmEmpty from '@/components/Main/Empty.vue'
  import LxmBlocked from '@/components/Main/Blocked.vue'
  import { getActivityItems } from '@/utils'
  import * as aTypes from '@/store/action-types'
  import * as mTypes from '@/store/mutation-types'
  export default {
    components: {
      LxmNav,
      LxmActivityItem,
      LxmMore,
      LxmBottomTabs,
      LxmEmpty,
      LxmBlocked
    },
    computed: {
      loading () {
        return this.$store.state.loading[aTypes.ACTIVITY_GET_LIST]
      },
      currentPage () {
        return this.$store.state.activity.currentPage
      },
      hasMore () {
        return this.$store.state.activity.hasMore
      },
      items () {
        const list = this.$store.state.activity.list
        return getActivityItems(list)
      },
      isEmpty () {
        return this.$store.state.activity.list.length === 0
      },
      blocked () {
        return !this.$store.state.teamInfo.dataEnabled
      }
    },
    mounted () {
      this.$store.commit(mTypes.SET_NAV_TITLE, '')
      if (!this.$store.state.loaded.activity.list) {
        this.$store.dispatch(aTypes.ACTIVITY_GET_LIST, {
          page: 1,
          append: false
        })
      }
    },
    methods: {
      moreClicked () {
        this.$store.dispatch(aTypes.ACTIVITY_GET_LIST, {
          page: this.currentPage + 1,
          append: true
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// List.vue?0ade7302